<div tabindex="0" class="me-banners--card article-card" *ngIf="data">
    <div class="me-banners--card__icon close-icon hidden">
        <i class="fal fa-times"></i>
    </div>
    <div class="me-banners--card__header">
        {{data.headline}}
    </div>

    <ng-container *ngIf="articles && articles.length">
        <div *ngFor="let article of articles" class="article-card--item" [routerLink]="['/me/article/' + article.slug]">
            <div class="article-card--item--image" [innerHTML]="article.content.previewImage | storyblokImage:'stb-image'">>
            </div>

            <div class="article-card--item--content">
                <div class="article-card--item--content__title"
                     [innerHTML]="article.name">
                </div>

                <div class="article-card--item--content__description"
                     [innerHTML]="article.content.highlight | storyblokRichtext">
                </div>
            </div>

            <div class="article-card--item--icon">
                <i class="fal fa-chevron-right"></i>
            </div>
        </div>
    </ng-container>
</div>